/* eslint-disable @typescript-eslint/no-use-before-define */
let uid = new Date().getTime();

export function getUid() {
  uid += 1;

  const id = hasCrypto() ? window.crypto.randomUUID() : uid;

  return `a${id}`;

  function hasCrypto() {
    return !!window?.crypto?.randomUUID;
  }
}
